<template>
  <span>
    <v-btn class="ml-2" small color="primary" dark @click="openDialog">
      <v-icon small left>mdi-puzzle</v-icon>
      Manage Hook
    </v-btn>

    <v-dialog v-model="dialog" width="900" persistent scrollable>
      <v-card>
        <v-card-title class="pb-2">
          <v-icon left color="primary">mdi-bell-cog</v-icon>
          Manage Notification Hook
        </v-card-title>

        <v-divider />

        <v-card-text style="max-height: 75vh; overflow-y: auto; padding-top: 16px;">
          <!-- Service & Method -->
          <v-row dense>
            <v-col cols="8">
              <feathers-vuex-find service="service-lists" :query="{}">
                <v-combobox
                  slot-scope="{ items }"
                  v-model="form.service"
                  label="Target Service"
                  :items="servicesFilter(items)"
                  :disabled="loading"
                  outlined
                  dense
                />
              </feathers-vuex-find>
            </v-col>
            <v-col cols="4">
              <v-combobox
                v-model="form.method"
                label="Method"
                :items="methodOptions"
                item-text="text"
                item-value="id"
                :disabled="loading"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-divider class="mb-4" />

          <!-- Data Replacement Visual Editor -->
          <div class="editor-section-label mb-2">
            <v-icon small left color="primary">mdi-code-json</v-icon>
            <strong>Data Replacement</strong>
            <span class="ml-2 grey--text text--darken-1" style="font-size:12px;">
              Build the payload that maps template placeholders to dynamic values
            </span>
          </div>

          <data-replacement-editor v-model="form.data" />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn v-if="!loading" small color="red" text @click="dialog = false">Cancel</v-btn>
          <v-btn small color="primary" text @click="UpdateNotificationHook" :loading="loading">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DataReplacementEditor from './DataReplacementEditor.vue';

export default {
  components: { DataReplacementEditor },

  props: {
    id: [Number, String],
    item: {
      type: Object,
      default() {
        return {
          id: null,
          nt_id: null,
          service: null,
          method: null,
          enable_record: null,
          data: null,
          transformer: null
        };
      }
    }
  },

  data() {
    return {
      dialog: false,
      loading: false,
      form: {
        nt_id: null,
        service: null,
        method: null,
        enable_record: null,
        data: null,
        transformer: null
      }
    };
  },

  computed: {
    methodOptions() {
      return [
        { id: 'CREATE', text: 'Create' },
        { id: 'UPDATE', text: 'Update' }
      ];
    },
    ...mapGetters('bh-notification-templates', { getNotificationTemplate: 'get' })
  },

  methods: {
    openDialog() {
      this.form = {
        nt_id: this.id,
        service: this.item ? this.item.service : null,
        method: this.item ? this.item.method : null,
        enable_record: this.item ? this.item.enable_record : null,
        data: this.item ? this.item.data : null,
        transformer: this.item ? this.item.transformer : null
      };
      this.dialog = true;
    },

    async UpdateNotificationHook() {
      try {
        this.loading = true;
        const method = typeof this.form.method === 'object' && this.form.method
          ? this.form.method.id
          : this.form.method;

        if (this.item && this.item.id) {
          this.item.nt_id = this.id;
          this.item.service = this.form.service;
          this.item.method = method;
          this.item.enable_record = !(!this.form.enable_record);
          this.item.data = this.form.data;
          this.item.transformer = this.form.transformer;
          const updatedItem = { ...this.item };
          delete updatedItem.id;
          delete updatedItem.createdAt;
          delete updatedItem.updatedAt;
          await this.patchHook([this.item.id, updatedItem]);
        } else {
          await this.createNewHook({
            ...this.form,
            nt_id: this.id,
            method,
            enable_record: !(!this.form.enable_record)
          });
          this.form = { nt_id: this.id, service: null, method: null, enable_record: null, data: null, transformer: null };
        }
        this.$emit('success');
        this.dialog = false;
      } catch (err) {
        console.log(err);
        this.$emit('error', err);
      } finally {
        this.loading = false;
      }
    },

    servicesFilter(items) {
      return [
        'authentication',
        ...(items.map(i => i.id).filter(service => [
          'logic-control',
          'cities',
          'countries',
          'regions',
          'logic-control-category',
          'bh-app-error-log',
          'bh-app-version',
          'bh-exp-tables',
          'access-control-services',
          'bh-user-obtained-exp',
          'bh-exp-hooks'
        ].indexOf(service) === -1))
      ];
    },

    parseTemplates(items) {
      return items.map(item => ({ id: item.id, text: item.target_type }));
    },

    ...mapActions('bh-notification-hooks', { createNewHook: 'create', patchHook: 'patch' })
  }
};
</script>

<style scoped>
.editor-section-label {
  display: flex;
  align-items: center;
}
</style>